export default __webpack_public_path__ + "static/media/coinsIllustrator.c0940e2d.svg";